/**
* file : TournamentRelated/Common/BetHistory.jsx
* 설명 : 베팅 내역
*/

import { Fnc } from "common/globals";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { SSE } from 'components/Common/ApiCall';

export default function BetHistory(props) {
  // 접속자 토큰 정보
  const { token } = useSelector(state => state.Client);
  // 토큰 정보 추출
  const info = Fnc.TokenSubstitution(token.access_token);
  // 데이터
  const [datas, setData] = useState();
  // 리스트 갯수
  const [listCount, setListCount] = useState(10)
  const showMore = () => {
    let count = listCount > datas.length ? datas.length : listCount + 10
    setListCount(count);
  }
  // SSE 통신
  useEffect(() => {
    const { start, stop } = SSE();

    start(`/bet?tournament_idx=${props.tournament_idx}&member_idx=${info.idx}`,
    (result) => {
      setData(result);
    }, (err) => {
      console.error('SSE Bet 통신 중 오류:', err);
    })

    return () => {
      stop();
    };
  }, []);

  return (
    <div className="zeus-tab-item">
      <div className="table-container">
        <table className="table_style1">
          <thead>
            <tr>
              <th>배팅번호</th>
              <th>베팅금액</th>
              <th>당첨금액</th>
              <th>손익금액</th>
              <th>상태</th>
              <th>베팅시각</th>
              <th>처리시각</th>
            </tr>
          </thead>
          <tbody>
            {
              !Fnc.Empty(datas) && datas.slice(0, listCount).map((data, index) => (
                <tr key={index} className={data.bet_result_type === 'cancel' ? 'cancel' : null}>
                  <td>{data.bet_no}</td>
                  <td className="align_r font_style1"><span className="won"></span>{Math.abs(data.bet_money).toLocaleString()}</td>
                  <td className="align_r font_style1"><span className="won"></span>{Math.abs(data.win_money).toLocaleString()}</td>
                  <td className="align_r font_style1"><span className="won"></span>{(data.win_money + data.bet_money).toLocaleString()}</td>
                  <td>{data.state}</td>
                  <td>{Fnc.FormatDate(data.bet_at, true)}</td>
                  <td>{Fnc.FormatDate(data.win_at, true)}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
        { Fnc.Empty(datas) && <div className='table-no-data'>베팅 내역이 존재하지 않아요</div> }
        {
          !Fnc.Empty(datas) &&
          listCount < datas.length && (
            <div className="btns_wrap mt_30 mb_30">
              <Link className="btn_more" onClick={showMore}>더불러오기</Link>
            </div>
          )
        }
      </div>
    </div>
  )
}